<template lang='pug'>
  .rich_text
    div(v-if='is_html')
      p
        | Step 1: Drop your HTML code below.
      p
        | Step 2: Click the </> button to see your HTML.
    .froala-editor
    el-input(
      v-show='false'
      v-model='landing_page_widget.draft_content.html'
      v-validate="!is_hero && 'required|min:8'"
      :name="landing_page_widget.id"
      :data-vv-as='get_field_name'
    )
    .error(v-if='errors.has(landing_page_widget.id)')
      span {{ get_error_message }}
    .color_picker_container(v-if="!is_hero && !is_html")
      label
        | Background Color
      pbxx_color_picker(
        :color='background'
        @input='on_background_changed')
</template>
<script>
  import * as $ from 'jquery'
  import _ from 'lodash'
  import { generate_menu } from '../utils/rich_text_menu_generator'

  export default {
    name: 'rich_text',
    props: {
      landing_page_widget: {
        type: Object,
        required: true
      },
      brand: {
        type: Object
      },
      landing_page: {
        type: Object,
        required: true
      },
      is_hero: {
        type: Boolean,
        required: true
      },
      is_html: {
        type: Boolean,
        required: true
      }
    },
    inject: {
      $validator: '$validator'
    },
    data() {
      return {
        background: this.landing_page_widget.draft_content.background_color || this.landing_page.background_color || '#F9F9F9',
        editor: null,

      }
    },
    computed: {
      custom_fonts() {
        const font_object = {}

        if (this.brand.fonts) {
          this.brand.fonts.forEach(font => {
            const family = font.family
            font_object[family] = family
          })
        }

        if (this.brand.custom_fonts) {
          this.brand.custom_fonts.forEach(font => {
            const family = font.family
            font_object[family] = family
          })
        }
        return font_object
      },
      get_error_message() {
        // TODO: Figure out a better way to do this
        let error_message = this.errors.first(this.landing_page_widget.id)
        error_message = error_message.replace('image +', '')
        error_message = error_message.replace('video +', '')
        error_message = error_message.replace('The hero field is required.', '')
        error_message = error_message.replace('The url field is required.', '')
        error_message = error_message.replace('The url field is not a valid URL.', '')
        return error_message
      },
      get_field_name() {
        const dual_widgets = ['image_text', 'video_text']
        if (_.includes(dual_widgets, this.landing_page_widget.widget.name)) {
          return 'text'
        }
        return this.landing_page_widget.widget.name
      },
      link_color() {
        return this.landing_page.link_color
      }
    },
    methods: {
      initialized(event, editor) {
        this.editor = editor
        $('.froala-editor').froalaEditor('html.set', this.landing_page_widget.draft_content.html)
      },
      on_background_changed(background) {
        this.background = background
        const widget = {...this.landing_page_widget}
        widget.draft_content.background_color = background
        document.getElementsByClassName('fr-element')[0].style.background = background
        this.$emit('input', widget)
      },
      on_content_changed(event, editor, html = '<p></p>') {
        const widget = {...this.landing_page_widget}
        widget.draft_content.html = html
        this.$emit('input', widget)
      }
    },
    mounted() {
      $.FroalaEditor.DefineIcon('liquid_variables', { NAME: 'cog', FA5NAME: 'cog' });
      $.FroalaEditor.RegisterCommand('liquid_variables', {
        title: 'Insert Variables',
        type: 'dropdown',
        focus: false,
        undo: false,
        html: generate_menu(),
        callback: (cmd, val) => {
          $('.froala-editor').froalaEditor('html.insert', `{{ ${val} }}`)
        }
      });

      $('.froala-editor')
        .on('froalaEditor.initialized', (e, editor) => {
          this.initialized(event, editor)
          if (this.is_html) {
            editor.codeView.toggle()
          }
          document.getElementsByClassName('fr-element')[0].style.background = this.background
        })
        .on('froalaEditor.contentChanged', (event, editor) => {
          this.on_content_changed(event, editor, $('.froala-editor').froalaEditor('html.get'))
        })

      $('.froala-editor').froalaEditor({
        key: 'YD3A3A2C2c1A6B5B4E2A3B2F2G3C4A3D-17GLGTI1DMJc1BWLg1PO==',
        fontFamily: {
          "Lato,sans-serif": 'Lato',
          "Lucida Sans Unicode,sans-serif": 'Lucida Sans',
          "Open Sans,sans-serif": 'Open Sans',
          "Trebuchet MS,sans-serif": 'Trebuchet',
          "Source Sans Pro,sans-serif": 'Source Sans Pro',
          "Roboto,sans-serif": 'Roboto',
          ...this.custom_fonts
        },
        toolbarSticky: false,
        toolbarVisibleWithoutSelection: false,
        fontFamilySelection: true,
        heightMin: 250,
        codeViewKeepActiveButtons: ['html'],
        toolbarButtons: this.is_html ? ['html'] : [
          'bold',
          'italic',
          'underline',
          'fontFamily',
          'fontSize',
          'color',
          'paragraphFormat',
          this.is_hero ? null : 'formatUL',
          this.is_hero ? null : 'align',
          '|',
          'subscript',
          'superscript',
          '|',
          'undo',
          'redo',
          this.is_hero ? null : 'insertLink',
          '|',
          'fullscreen',
          this.is_hero ? null : 'html',
          '|',
          'liquid_variables'
        ]
      })
    }
  }
</script>
<style>
  .color_picker_container {
    margin-top: 20px;
  }

  .error {
    color: red;
  }

</style>
